import { Component } from '@angular/core';

@Component({
  selector: 'country-icon',
  standalone: true,
  imports: [],
  templateUrl: './country.component.html',
  styleUrl: './country.component.scss'
})
export class CountryIcon {}